import axios from 'axios';
import interceptors from './interceptors';
import decodeArrayBuffer from './util';

export const http = axios.create({
  baseURL: axios.defaults.baseURL,
});

export function setToken(token) {
  if (token === undefined) return;
  http.defaults.headers.common.Authorization = `${token}`;
}

export const httpPlugin = {
  install: (app, options) => {
    interceptors(http, options.store, options.router);

    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$http = http;
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$setToken = setToken;
  },
};

export const decodeMessagesArrayBuffer = decodeArrayBuffer;
